import LiveMaterialTable from 'common/components/LiveMaterialTable';
import React from "react"
import AddIcon from '@material-ui/icons/LibraryAdd';
import { calculateHeight } from "common/services/util";
import { Check, Clear, CloudDownload, PhoneIphone, Print, Visibility, Email, SwapHoriz } from "@material-ui/icons";
import { Button } from "@material-ui/core";
import TableTitle from 'common/components/TableTitle';

const pressEnter = () => {
    const buttonSave = document.querySelector("button[title='Save']")
    if (buttonSave) {
        buttonSave.click()
    }
}

const TableTickets = ({
    columns,
    data,
    onTicketsAdd,
    onTicketsUpdate,
    onTicketsDelete,
    onTicketPrint,
    onSendTicketByEmail,
    onCreateCanjeInvoice,
    tableRefProp,
    getRowStyle,
    onFilterChange,
}) => {
    return (
        <div className="zebra-table">
            <LiveMaterialTable
                title={<TableTitle>Tickets</TableTitle>}
                tableRef={tableRefProp}
                icons={{
                    'Add': () => <Button onClick={() => setTimeout(pressEnter, 10)} variant="contained" color="primary">
                                    <AddIcon fontSize='large' style={{ marginRight: '10px' }} /> CREAR TICKET
                                 </Button>
                }}
                actions={[
                    {
                        icon: () => <Visibility />,
                        tooltip: "Visualizar",
                        onClick: (event, rowData) => onTicketPrint(rowData, "view")
                    },
                    {
                        icon: () => <Print />,
                        tooltip: "Imprimir",
                        onClick: (event, rowData) => onTicketPrint(rowData, "print")
                    },
                    {
                        icon: () => <CloudDownload />,
                        tooltip: "Descargar",
                        onClick: (event, rowData) => onTicketPrint(rowData, "save")
                    },
                    {
                        icon: () => <PhoneIphone />,
                        tooltip: "Enviar por Whatsapp",
                        onClick: (event, rowData) => onTicketPrint(rowData, "upload")
                    },
                    {
                        icon: () => <Email />,
                        tooltip: "Enviar por email",
                        onClick: (event, rowData) => onSendTicketByEmail && onSendTicketByEmail(rowData)
                    },
                    rowData => ({
                        icon: () => <SwapHoriz style={{ color: rowData.invoiceCanjeId ? '#9e9e9e' : '#1976d2' }} />,
                        tooltip: rowData.invoiceCanjeId ? `Factura canje ya creada (${rowData.numCanjeInvoice})` : "Crear factura canje",
                        onClick: (event, rowData) => onCreateCanjeInvoice && onCreateCanjeInvoice(rowData),
                        disabled: Boolean(rowData.invoiceCanjeId)
                    }),
                    data => ({
                        icon: () => data.incorrect ? <Check /> : <Clear />,
                        tooltip: "Marcar correcto/incorrecto",
                        onClick: (event, rowData) => onTicketsDelete(rowData)
                    })
                ]}
                columns={columns}
                data={data}
                options={{
                    sorting: true,
                    filtering: true,
                    toolbarButtonAlignment: 'left',
                    actionsColumnIndex: 1,
                    addRowPosition: 'first',
                    maxBodyHeight: calculateHeight(),
                    pageSize: 50,
                    pageSizeOptions: [5, 10, 25, 50, 100],
                    rowStyle: (rowData, index) => {
                        // Base: zebra + selección (si la pasas)
                        const base = getRowStyle ? { ...getRowStyle(rowData, index) } : {};
                        // Prioridad absoluta: si tu botón marcó incorrecto => rojo
                        if (rowData.incorrect) {
                            return {
                                ...base,
                                backgroundColor: 'red',
                                // opcional: también cambia el hover cuando está en rojo
                                ['--row-hover']: '#FF0000'
                            };
                        }
                        return base;
                    }
                }}
                onFilterChange={() => onFilterChange && setTimeout(onFilterChange, 50)}
                onChangePage={() => onFilterChange && setTimeout(onFilterChange, 50)}
                onChangeRowsPerPage={() => onFilterChange && setTimeout(onFilterChange, 50)}
                editable={{
                    onRowAdd: onTicketsAdd,
                    onRowUpdate: onTicketsUpdate
                }}
            />
        </div>
    )
}

export default TableTickets
